import { useQuery } from '@tanstack/react-query';
import { catalogsKeys } from './catalogs.keys';
import { getModels } from './catalogs.api';
export const useModelsQuery = () => {
    return useQuery({
        queryKey: catalogsKeys.models(),
        queryFn: () => getModels(),
        staleTime: Infinity
    });
};
//# sourceMappingURL=catalogs.query.js.map